module.exports = __webpack_public_path__ + "static/media/icon.6ce0f2a2.png";